<template>
  <div>
    <input
      v-model="search"
      type="text"
      placeholder="Search Icon library"
      class="search-icon-field"
    />
    <div class="icon-container">
      <div v-for="(icon, id) in filteredIcons" :key="id">
        <cat-icon
          :icon="icon.name.replace('icon-', '')"
          :iconLabel="icon.label.replace('icon-', '')"
        ></cat-icon>
        <span class="icon-text">{{ icon.name.replace("icon-", "") }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Mixins } from "vue-facing-decorator";
import { Icons } from "@/design-system/design-styles/data/icons.js";
import CatIcon from "@/components/utilities/catIcon.vue";

@Component({
  name: "icon-lib",
  components: { CatIcon }
})
export default class IconLib extends Vue {
  public search: string = "";

  private readonly icons = Icons;

  get filteredIcons(): string[] {
    return this.icons.filter((icon) => {
      return icon.name.match(this.search);
    });
  }
}
</script>
